
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isLoggedIn } from '../auth/auth';
import { buildLoginUrlWithReturnTo, locationToReturnTo, savePendingReturnTo } from '../auth/returnTo';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();

    if (!isLoggedIn()) {
        const returnTo = locationToReturnTo(location, '/mypage');
        savePendingReturnTo(returnTo);
        return <Navigate to={buildLoginUrlWithReturnTo(returnTo)} state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
